import type { TelegramChat } from "@/lib/telegramBot";

export function resolveTelegramChatLabel(value: string | number, chatsById?: Map<string, TelegramChat>): string | null {
  const normalized = String(value).trim();
  if (!normalized) return null;

  const chat = chatsById?.get(normalized);
  if (chat) {
    return chat.chatTitle || chat.chatUsername || normalized;
  }

  if (/^-?\d+$/.test(normalized)) {
    return "Telegram chat";
  }

  return normalized;
}
